import { ReactElement, useMemo } from 'react'
import { useSceneMarker } from '@editorHooks'
import { SEISMIC_MASS_COLOR, SEISMIC_STIFFNESS_COLOR } from '../../constants'
import { Point, StoreyLocation, toCentroid } from './utils'

interface Props {
  massLocation?: StoreyLocation
  stiffnessLocation?: StoreyLocation
  /** Ceiling elevation of this storey, or undefined while its height is unusable. */
  elevation?: number
}

/** `useSceneMarker` always wants a position; this one is never shown. */
const UNUSED_POSITION: Point = { x: 0, y: 0, z: 0 }

/** The two centroids of a single storey, in the colours their fields carry. */
const StoreyCentroidMarkers = ({
  massLocation,
  stiffnessLocation,
  elevation,
}: Props): ReactElement => {
  const massCentroid = useMemo(() => toCentroid(massLocation, elevation), [massLocation, elevation])
  const stiffnessCentroid = useMemo(
    () => toCentroid(stiffnessLocation, elevation),
    [stiffnessLocation, elevation],
  )

  useSceneMarker({
    marker: massCentroid ?? UNUSED_POSITION,
    enabled: massCentroid !== undefined,
    color: SEISMIC_MASS_COLOR,
    animated: false,
    disableDepthTest: true,
  })

  useSceneMarker({
    marker: stiffnessCentroid ?? UNUSED_POSITION,
    enabled: stiffnessCentroid !== undefined,
    color: SEISMIC_STIFFNESS_COLOR,
    animated: false,
    disableDepthTest: true,
  })

  return <></>
}

export default StoreyCentroidMarkers
